import React from 'react';

// CSS
import Styles from './Chip.module.css';

const Chip = ({ active, text, handleClick }) => {
    
    return (
        <div
            className={Styles.Chip}
            style={{
                backgroundColor: active ? '#0DA15A' : 'var(--secondary)',
                borderColor: active ? '#0DA15A' : 'var(--border)',
                color: active ? 'white' : 'var(--muted-foreground)',
            }}
            onClick={ (index) => handleClick(index) }
        >{text}</div>
    )
}

export default Chip;
